<dialog
  noxo-dialog
  aria-labelledby="cookie-preferences-title"
  (close)="closed.emit()">
  <noxo-dialog-header>
    <h2
      noxo-dialog-title
      id="cookie-preferences-title"
      i18n="@@cookieConsent.preferences.title">
      Cookie preferences
    </h2>
    <button
      type="button"
      noxo-icon-button
      shape="round"
      i18n-aria-label="@@cookieConsent.preferences.close"
      aria-label="Close"
      (click)="close()">
      <noxo-icon icon="xmark" />
    </button>
  </noxo-dialog-header>
  <p
    class="note"
    i18n="@@cookieConsent.preferences.intro">
    Strictly necessary cookies are always on — they run the session, security and your basic preferences. The rest is
    your choice.
  </p>
  <label class="row">
    <span class="text">
      <strong i18n="@@cookieConsent.category.strictlyNecessary.title">Strictly necessary</strong>
      <span i18n="@@cookieConsent.category.strictlyNecessary.body"
        >Session, security and basic preferences. Always on.</span
      >
    </span>
    <noxo-switch>
      <input
        type="checkbox"
        role="switch"
        checked
        disabled />
    </noxo-switch>
  </label>
  <label class="row">
    <span class="text">
      <strong i18n="@@cookieConsent.category.functional.title">Functional</strong>
      <span i18n="@@cookieConsent.category.functional.body"
        >Remember your language, theme and recently viewed projects. No personal profiling.</span
      >
    </span>
    <noxo-switch>
      <input
        #functional
        type="checkbox"
        role="switch"
        [checked]="draft().functional"
        (change)="set('functional', functional.checked)" />
    </noxo-switch>
  </label>
  <label class="row">
    <span class="text">
      <strong i18n="@@cookieConsent.category.analytics.title">Analytics</strong>
      <span i18n="@@cookieConsent.category.analytics.body"
        >How the platform is used, so we can improve it. Google Analytics with an anonymised IP.</span
      >
    </span>
    <noxo-switch>
      <input
        #analytics
        type="checkbox"
        role="switch"
        [checked]="draft().analytics"
        (change)="set('analytics', analytics.checked)" />
    </noxo-switch>
  </label>
  <label class="row">
    <span class="text">
      <strong i18n="@@cookieConsent.category.marketing.title">Marketing</strong>
      <span i18n="@@cookieConsent.category.marketing.body"
        >Personalised marketing communications and campaign measurement.</span
      >
    </span>
    <noxo-switch>
      <input
        #marketing
        type="checkbox"
        role="switch"
        [checked]="draft().marketing"
        (change)="set('marketing', marketing.checked)" />
    </noxo-switch>
  </label>
  <noxo-dialog-actions>
    <button
      type="button"
      noxo-button="secondary"
      (click)="onlyNecessary()"
      i18n="@@cookieConsent.action.rejectAll">
      Only necessary
    </button>
    <button
      type="button"
      noxo-button="primary"
      (click)="submit(draft())"
      i18n="@@cookieConsent.action.save">
      Save preferences
    </button>
  </noxo-dialog-actions>
</dialog>
